import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SALEORDERPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SaleOrderParameter.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SaleOrderParameter.Code')
    .required()
    .minLength(2)
    .maxLength(10)
    .build(),
];

export const SALEORDERPARAMETER_CONFIG = {
  entityName: 'SaleOrderParameter',
  localizationKey: 'Controlling::Entity.SaleOrderParameter',
  fields: SALEORDERPARAMETER_FIELDS,
  permission: 'ControllingLiquidations.SaleOrderParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
